import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@bibliocommons/base-buttons';

import { sendEContentAction, ECONTENT_ACTIONS } from 'app/helpers/econtent/nativeEContentBridge';

export default function FulfilmentButton({
  modalActions,
  modalKey,
  trackCheckoutConsumeAccess,
  bibId,
  econtentId,
  format,
  title
}) {
  function handleOpen() {
    // Track access before the native hand-off (matching DownloadButton) so the event
    // isn't lost on a native open — native doesn't emit a replacement, so skipping it
    // here would make access look like it's declining as native adoption grows.
    if (typeof trackCheckoutConsumeAccess === 'function') {
      trackCheckoutConsumeAccess(bibId);
    }

    // Inside the native app (eContent capability), hand "Read Now" to the native reader
    // instead of opening the fulfilment modal. Otherwise fall through to web behavior.
    const handledByNative = sendEContentAction(ECONTENT_ACTIONS.OPEN, econtentId, { format, title });
    if (handledByNative) {
      return;
    }

    modalActions.openModal(modalKey, { accountRequired: true });
  }

  return (
    <Button className="cp-fulfilment-button" handleClick={handleOpen} dataKey="fulfilment-button">
      <FormattedMessage id="access_this_item" />
    </Button>
  );
}

FulfilmentButton.propTypes = {
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalKey: PropTypes.string.isRequired,
  trackCheckoutConsumeAccess: PropTypes.func,
  bibId: PropTypes.string,
  econtentId: PropTypes.string,
  format: PropTypes.string,
  title: PropTypes.string
};
